var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.96908V3.93816L3.55786 3.96607L7.11571 3.99398L7.55386 4.25152C7.79487 4.3932 8.10475 4.67938 8.24247 4.88753L8.49295 5.266L8.53886 20.1906L8.58476 35.1154L9.18157 35.2174C10.2429 35.3989 11.3816 35.8249 12.0877 36.3048C12.2803 36.4356 12.4705 36.5426 12.5105 36.5426C12.5506 36.5426 12.5706 29.4465 12.5551 20.7733C12.5284 5.85224 12.518 4.9743 12.3604 4.45306C11.8367 2.72123 10.7415 1.3889 9.23362 0.649412C8.01101 0.0498559 7.57378 0 3.53876 0H0V1.96908ZM21.8521 7.94261V14.5997L29.7712 14.5763L37.6903 14.5528V7.94205V1.33133L34.7293 1.30709L31.7682 1.28285V3.94679V6.61073H29.7483H27.7283V3.94807V1.28542H24.7902H21.8521V7.94261ZM18.5468 26.4888V34.4309H29.7942H41.0416V26.4888V18.5468H36.4063H31.7711L31.7466 21.1865L31.7223 23.8262H29.7483H27.7742L27.7499 21.1865L27.7255 18.5468H23.1362H18.5468V26.4888ZM14.4157 38.4478C14.416 38.4857 14.5015 38.6406 14.6056 38.7921C15.0933 39.5019 15.5605 40.7719 15.7708 41.9598L15.844 42.3729L31.0596 42.3962L46.2751 42.4194V40.3992V38.3789H30.3451C21.5836 38.3789 14.4153 38.4099 14.4157 38.4478ZM6.54609 39.3296C3.81889 40.3673 3.07638 43.7697 5.1302 45.8178C8.30739 48.986 13.4114 45.2206 11.4073 41.187C10.5809 39.5241 8.31281 38.6574 6.54609 39.3296Z",
    fill: "#7DA4B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/total-orders.0b698cb538ee01ddf1fe8ce0b07da18a.svg";
export { ForwardRef as ReactComponent };